import React from 'react';
import { Line } from '../../Common';
import Slider from 'react-slick';
import { Image } from '../../Common'
import { photosOpts } from '../SliderConfig';

function Photos() {
  return (
    <Line
      title="Фотографии"
      style={{ margin: '0 auto', marginBottom: '2rem'}}
    >
      <div className="carouselcont">
        <Slider {...photosOpts}>
          <div>
            <Image src="/photos/sg208345.jpg" thumb="/photos/sg208345-low.jpg"/>
          </div>
          <div>
            <Image src="/photos/sg208346.jpg" thumb="/photos/sg208346-low.jpg"/>
          </div>
          <div>
            <Image src="/photos/sg208358.jpg" thumb="/photos/sg208358-low.jpg"/>
          </div>
          <div>
            <Image src="/photos/sg208366.jpg" thumb="/photos/sg208366-low.jpg"/>
          </div>
          <div>
            <Image src="/photos/sg208502.jpg" thumb="/photos/sg208502-low.jpg"/>
          </div>
        </Slider>
      </div>
    </Line>
  );
}

export default Photos;



// WEBPACK FOOTER //
// ./src/components/About/Common/Photo.jsx